import React, { useRef } from 'react';
import './Input.scss';
import './Input-media.scss';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import ErrorText from '../ErrorText/ErrorText';
import { GetMarginTop } from './functions';

interface Props {
  name: string;
  label: string;
  onChange: (file: File | null) => void;
  accept?: string;
  maxSize?: number; // in MB
  error?: string | null;
  required?: boolean;
  widthWindow?: number;
  marginTop?: number;
}

const InputFile = ({
  name,
  label,
  onChange,
  accept = '.pdf,.doc,.docx',
  maxSize = 5,
  error,
  required = false,
  widthWindow,
  marginTop = 32,
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = React.useState<string | null>(null);
  const [fileError, setFileError] = React.useState<string | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      setFileName(null);
      setFileError(null);
      onChange(null);
      return;
    }

    // Check file size
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSize) {
      setFileError(`Размер файла не должен превышать ${maxSize} МБ`);
      setFileName(null);
      onChange(null);
      return;
    }

    setFileName(file.name);
    setFileError(null);
    onChange(file);
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const displayError = error || fileError;

  return (
    <div className="input">
      {label ? (
        <p className="input__label" style={{ marginTop: widthWindow ? GetMarginTop({ widthWindow, marginTop }) : marginTop }}>
          {label}{required ? ' *' : ''}
        </p>
      ) : null}
      <div className="input-file">
        <input
          ref={fileInputRef}
          type="file"
          name={name}
          accept={accept}
          onChange={handleFileChange}
          className="input-file__hidden"
          style={{ display: 'none' }}
        />
        <button
          type="button"
          onClick={handleButtonClick}
          className={`input__field input-file__button${displayError ? ' input__field_error' : ''}`}
        >
          {fileName || 'Выберите файл'}
        </button>
      </div>
      {displayError ? <span className="input__error"></span> : null}
      {displayError ? ErrorText(displayError) : null}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(InputFile));
